/* eslint-disable no-nested-ternary */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import { useHistory, useLocation } from 'react-router-dom';
import sanitizeHtml from 'sanitize-html';
import CustomTypography from '@src/new-components/Typography';
import ROUTES from '@src/constants/route';
import {
  Box,
  Button,
  Divider,
  List,
  ListItem,
  // ListItem,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import queryString from 'query-string';
import camelcaseKeys from 'camelcase-keys';
import { Check, Clear } from '@mui/icons-material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  DURATION,
  FREE_PACKAGE_CODES,
  PACK_DURATION,
  PACKAGE_CHANGE_TYPES,
  PACKAGE_CODE,
  PACKAGE_CODE_V3,
  PACKAGE_EXPIRED,
  PACKAGE_LEVEL,
  PACKAGE_TYPE,
} from '@src/constants/package';
import actions from '@src/redux/actions';
import i18n from '@src/languages';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import apis from '@src/apis';
import { trackFreePlanActivated } from '@src/services/moengage';
import ProcessHandler from '@src/components/ProcessHandler';
import { EVENT_TYPE, LANGUAGE } from '@src/constants';
import { ORDER_STATUS } from '@src/constants/order';
import NotificationDialog from '@src/components/NotificationDialog';
import StackedAvatars from '@src/components/StackedAvatars';
import { CRM_URL, VBEE_CONSOLE_URL } from '@src/configs';
import { capitalize, max, min } from 'lodash';
import { checkVietNam } from '@src/utils/checkCountry';
import { delay } from '@src/utils/delay';
import { COLOR } from '@src/styles/color';
import {
  calculateCharacterPurchase,
  getFakeEndTimeDiscountForPackage,
  getPackageChangeType,
  getPackageCurrentPrice,
  checkStudioCustomPackage,
  getTotalPricePackage,
} from '@src/services/package';
// import PopularIcon from '@src/assets/icons/popular.svg';
import Tooltip from '@src/components/Tooltip';
import avatarMP11 from '@src/assets/avatars/avatar-mp-1-1.png';
import avatarMP12 from '@src/assets/avatars/avatar-mp-1-2.png';
import avatarMP13 from '@src/assets/avatars/avatar-mp-1-3.png';
import avatarMP21 from '@src/assets/avatars/avatar-mp-2-1.png';
import avatarMP22 from '@src/assets/avatars/avatar-mp-2-2.png';
import avatarMP23 from '@src/assets/avatars/avatar-mp-2-3.png';
import avatarMP31 from '@src/assets/avatars/avatar-mp-3-1.png';
import avatarMP32 from '@src/assets/avatars/avatar-mp-3-2.png';
import avatarMP33 from '@src/assets/avatars/avatar-mp-3-3.png';
import { useCheckDubbingRoute } from '@src/hooks/useCheckDubbingRoute';
import { getSavedPriceBasePrice } from '@src/services/voucher';
import useHandleOrderError from '@src/hooks/useHandleOrderError';
import { PAYMENT_CURRENCY_UNIT } from '@src/constants/payment';
import {
  DEFAULT_TIME_TO_RESET_COUNTDOWN,
  VOUCHER_TYPE,
} from '@src/constants/voucher';
import {
  StyledNewPackageItemV2,
  StyledNewPackageItemWrapper,
} from './index.style';
import NewCountdownBanner from './NewCountdownBanner';
import AmountCredits from './AmountCredits';
import PackageHeader from './components/PackageHeader';
import NewCreditsSlider from './NewCreditSlider';

const formatNumber = (num, language = 'vi') => {
  const format = (value) =>
    `${value.toLocaleString(language, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    })}K`;

  if (num >= 1e3) return format(num / 1e3);
  return num.toString();
};

const NewPackageItem = ({
  packagesComparisonEnabled,
  scrollToPackagesComparison,
  packages,
  pkg,
  saleOffPercentage,
  monthlyPriceWithSaleOff,
  correspondMonthPrice,
  totalPrice,
  isMobile,
  duration,
  hasDiscountPackage,
  firstPaidVoucher,
  canUseVouchers = [],
  packageTopUp,
  currentUsingPackage,
  setPackages,
  correspondMonthPkg,
  buyContainerMinHeight = 80,
}) => {
  const isDubbingRoute = useCheckDubbingRoute();
  const { t } = useTranslation();
  const { language } = i18n;
  const dispatch = useDispatch();
  const history = useHistory();
  const { handleOrderError } = useHandleOrderError();
  const location = useLocation();
  const { voucherCode, bannerType } = camelcaseKeys(
    queryString.parse(location.search) || {},
  );
  const { user = {} } = useSelector((state) => state.auth);
  const { usingPackage, latestOrder, usingDubbingPackage, latestDubbingOrder } =
    useSelector((state) => state.user);
  const userRef = useRef(user);
  const [bestVoucher, setBestVoucher] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState({
    createFreeOrder: false,
    cancelOrder: false,
  });
  const [highlight, setHighlight] = useState(false);
  const [isDiscountPackage, setIsDiscountPackage] = useState(false);
  const [packageContents, setPackageContents] = useState([]);
  const [totalRemainingPrice, setTotalRemainingPrice] = useState(0);

  // Change credit option
  const maxNumberOptionCredit = useMemo(
    () =>
      max(pkg?.cycle?.creditOptions?.map((item) => item.creditsPerCycle) || []),
    [pkg],
  );

  const minNumberOptionCredit = useMemo(
    () =>
      min(pkg?.cycle?.creditOptions?.map((item) => item.creditsPerCycle) || []),
    [pkg],
  );

  const [currentCredits, setCurrentCredits] = useState(minNumberOptionCredit);
  const handleChangeListPackages = (newValue) => {
    const optionCredit = pkg?.cycle?.creditOptions?.find(
      (opt) => opt?.creditsPerCycle === newValue,
    );
    if (!optionCredit) return;

    const updatedPackage = {
      ...pkg,
      price: optionCredit.vndPrice,
      usdPrice: optionCredit.usdPrice,
      monthlyPrice: optionCredit.vndMonthlyPrice,
      usdMonthlyPrice: optionCredit.usdMonthlyPrice,
      autoRenew: {
        active: pkg?.autoRenew?.active,
        vndPrice: optionCredit.autoRenewVndPrice,
        usdPrice: pkg?.autoRenew?.usdPrice,
      },
      cycle: {
        ...pkg?.cycle,
        creditsPerCycle: optionCredit.creditsPerCycle,
      },
    };

    let updatedCorrespondMonthPkg = null;
    if (duration === DURATION.YEARLY) {
      const optionCreditMonth = correspondMonthPkg?.cycle?.creditOptions?.find(
        (opt) => opt?.creditsPerCycle === newValue,
      );

      if (optionCreditMonth) {
        updatedCorrespondMonthPkg = {
          ...correspondMonthPkg,
          price: optionCreditMonth.vndPrice,
          usdPrice: optionCreditMonth.usdPrice,
          monthlyPrice: optionCreditMonth.vndMonthlyPrice,
          usdMonthlyPrice: optionCreditMonth.usdMonthlyPrice,
        };
      }
    }

    setPackages((prev) => {
      const filtered = prev.filter(
        (p) => p?.code !== pkg?.code && p?.code !== correspondMonthPkg?.code,
      );

      return [
        ...filtered,
        updatedPackage,
        ...(updatedCorrespondMonthPkg ? [updatedCorrespondMonthPkg] : []),
      ];
    });
  };

  const handleChangeCredits = (_, newValue) => {
    if (newValue > maxNumberOptionCredit || newValue < minNumberOptionCredit) {
      return;
    }
    setCurrentCredits(newValue);
    handleChangeListPackages(newValue);
  };

  const marks = [
    {
      value: 0,
      label: '',
    },
    ...(pkg?.cycle?.creditOptions?.map((option) => ({
      value: option?.creditsPerCycle,
      label: t('remainCredits', {
        numberCharacters: formatNumber(option?.creditsPerCycle, language),
      }),
    })) || []),
    {
      value: maxNumberOptionCredit + maxNumberOptionCredit,
      label: '',
    },
  ];

  const [
    remainingValueOfTheCurrentPackage,
    setRemainingValueOfTheCurrentPackage,
  ] = useState({ price: 0, usdPrice: 0 });
  const isCustomPackage = checkStudioCustomPackage(
    currentUsingPackage?.type,
    currentUsingPackage?.level,
  );

  const isVietNam = checkVietNam();

  const checkExpiredDate = (expiryDate) => {
    if (!expiryDate) return false;
    return moment().isAfter(expiryDate);
  };

  const isExpiredPackage = checkExpiredDate(user?.packageExpiryDate);

  const { code } = pkg;
  const { price, usdPrice } = getPackageCurrentPrice(pkg, true);
  const isDiscountUsingVoucher =
    bestVoucher?.value &&
    [VOUCHER_TYPE.PERCENT, VOUCHER_TYPE.PRICE].includes(bestVoucher?.type);
  const isUsingFreePackage =
    [PACKAGE_LEVEL.BASIC, PACKAGE_LEVEL.DUBBING_BASIC].includes(pkg.level) &&
    ((!isDubbingRoute && usingPackage.code === pkg.code) ||
      (isDubbingRoute && usingDubbingPackage?.code === pkg.code));
  const isPaygPackage =
    code === PACKAGE_CODE.API_ENTERPRISE_YEAR_V2 && isVietNam;
  const showPackageTotalPrice =
    duration !== DURATION.MONTHLY && price !== 0 && !isPaygPackage;

  const isApplyFirstPaidVoucher =
    (bestVoucher?.description || 0) === (firstPaidVoucher?.description || 1);
  const getBestVoucherForUser = () => {
    // Check if not using free package or not have voucher to use or not api enterprise year
    if (
      !canUseVouchers ||
      canUseVouchers.length === 0 ||
      pkg.code === PACKAGE_CODE.API_ENTERPRISE_YEAR_V2 ||
      pkg.code === PACKAGE_CODE.STUDIO_FREE_V3
    ) {
      setBestVoucher();
      return;
    }

    if (canUseVouchers.length > 0) {
      setBestVoucher(canUseVouchers[0]);
    }
  };

  const handleCreateFreeOrder = async (packageId) => {
    if (!isDubbingRoute && usingPackage.level === PACKAGE_LEVEL.BASIC) return;

    if (
      isDubbingRoute &&
      usingDubbingPackage?.level === PACKAGE_LEVEL.DUBBING_BASIC
    )
      return;

    if (latestOrder.status === ORDER_STATUS.PENDING) {
      setOpenDialog(true);
      return;
    }

    setLoading({ ...loading, createFreeOrder: true });
    const orderData = await apis.orders.createOrder({
      packageId,
      isGlobal: !isVietNam,
      downgradePackage: true,
    });
    setLoading({ ...loading, createFreeOrder: false });

    if (!orderData?.status) {
      // Check for error code 6001 and show popup
      if (handleOrderError(orderData)) {
        return;
      }
    }

    if (orderData.status) {
      trackFreePlanActivated({
        previousPackageCode: usingPackage?.code,
      });
      if (isDubbingRoute)
        dispatch(actions.user.getLatestDubbingOrderSuccess(orderData.result));
      else dispatch(actions.user.getLatestOrderSuccess(orderData.result));
      dispatch(
        actions.noti.push({
          severity: 'success',
          message: 'buyPackageSuccessfully',
        }),
      );
      if (orderData.result.type === PACKAGE_TYPE.DUBBING) {
        dispatch(
          actions.user.getUsingDubbingPackageSuccess(orderData.result.package),
        );
        dispatch(
          actions.auth.updateUserInfo({
            ...userRef.current,
            dubbing: {
              ...userRef.current.dubbing,
              packageCode: orderData.result?.package?.code,
              packageExpiryDate: orderData.result?.packageExpiryDate,
            },
          }),
        );
        history.push(ROUTES.HOME_DUBBING);
      } else {
        dispatch(actions.user.getUsingPackageSuccess(orderData.result.package));
        history.push(ROUTES.TTS);
      }
      return;
    }

    dispatch(
      actions.noti.push({ severity: 'error', message: 'buyPackageFailure' }),
    );
  };

  const minCreditTopup = packageTopUp?.creditPurchaseOptions?.sort(
    (a, b) => a - b,
  )[0];

  const { customPrice, customUsdPrice } = calculateCharacterPurchase(
    minCreditTopup,
    packageTopUp,
  );

  const apiUsingPackage = packages?.find(
    (pack) => pack?.code === user?.apiUsageOptions?.code,
  );
  const isUpgradePackage = useMemo(() => {
    const determinePackageChange = () => {
      if (!usingPackage) return null;
      return getPackageChangeType({
        currPackage: pkg,
        prevPackage: apiUsingPackage || usingPackage,
        prevPackageExpiredDate: apiUsingPackage
          ? user?.apiPackage?.packageExpiryDate
          : user?.packageExpiryDate,
      });
    };
    return determinePackageChange() === PACKAGE_CHANGE_TYPES.UPGRADE;
  }, [pkg, usingPackage, apiUsingPackage, user]);

  const minPriceTopup = isVietNam ? customPrice : customUsdPrice;
  const sentEventAddToCartMoEngage = (packageCode, paymentUrl) => {
    const [product, packageItem, period] = pkg.code.split('-');

    const isTopUp = packageCode === packageTopUp?.code;
    const hasRemainingValue = isUpgradePackage || isCustomPackage;
    let finalPrice;
    if (hasRemainingValue) {
      finalPrice = totalRemainingPrice;
    } else if (showPackageTotalPrice) {
      finalPrice = totalPrice;
    } else {
      finalPrice = price;
    }

    const addToCartEventData = {
      event: EVENT_TYPE.ADD_TO_CART,
      userId: user?.id,
      email: user.email,
      package_code: packageCode,
      product,
      plan: packageItem,
      period,
      voucher_type: bestVoucher?.type,
      voucher_code: bestVoucher?.code,
      voucher_amount: bestVoucher?.value,
      voucher_title: isVietNam
        ? bestVoucher?.title?.vi
        : bestVoucher?.title?.en,
      package_price: isVietNam ? pkg.price : pkg.usdPrice,
      price: finalPrice,
      ...(hasRemainingValue
        ? { remaining_package_value: remainingValueOfTheCurrentPackage?.price }
        : {}),
      isTopUp,
      // Set undefined to avoid overriding data from other event cases
      min_credit_topup: undefined,
      min_price_topup: undefined,
      url: paymentUrl,
      currency_unit: isVietNam
        ? PAYMENT_CURRENCY_UNIT.VND
        : PAYMENT_CURRENCY_UNIT.USD,
    };

    const addToCartTopUpEventData = {
      event: EVENT_TYPE.ADD_TO_CART,
      userId: user?.id,
      email: user.email,
      product,
      package_code: packageCode,
      // Set undefined to avoid overriding data from other event cases
      period: undefined,
      voucher_type: undefined,
      voucher_code: undefined,
      voucher_amount: undefined,
      package_price: undefined,
      isTopUp,
      min_credit_topup: minCreditTopup,
      min_price_topup: minPriceTopup,
      url: paymentUrl,
      currency_unit: isVietNam
        ? PAYMENT_CURRENCY_UNIT.VND
        : PAYMENT_CURRENCY_UNIT.USD,
    };
    window.dataLayer.push(
      isTopUp ? addToCartTopUpEventData : addToCartEventData,
    );
  };

  const handleBuyPackage = async (topUpPackageCode = '') => {
    let packageCode = pkg?.code;
    if (topUpPackageCode) {
      packageCode = topUpPackageCode;
    }
    if (pkg.price === 0) {
      if (isUsingFreePackage) return;
      await delay(1000);
      handleCreateFreeOrder(pkg.id);
      return;
    }

    const buildSearchParams = (params) => {
      const searchParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          searchParams.append(key, value);
        }
      });
      return `?${searchParams.toString()}`;
    };

    const baseParams = {
      package: packageCode,
      creditsPerCycle:
        pkg?.cycle && !topUpPackageCode
          ? pkg?.cycle?.creditsPerCycle
          : undefined,
    };

    const search =
      voucherCode && !topUpPackageCode
        ? buildSearchParams({
            ...baseParams,
            voucherCode,
            bannerType,
            packageCode: pkg?.code,
          })
        : buildSearchParams({
            ...baseParams,
          });

    // Push event to MoEngage
    const moEngagePaymentUrl = `${CRM_URL}${ROUTES.PAYMENT}${search}`;
    sentEventAddToCartMoEngage(packageCode, moEngagePaymentUrl);

    if (pkg.type === PACKAGE_TYPE.API) {
      window.location.assign(`${VBEE_CONSOLE_URL}/payments${search}`);
    } else if (pkg.type === PACKAGE_TYPE.DUBBING) {
      history.push(`${ROUTES.PAYMENT_DUBBING}${search}`);
    } else {
      history.push(`${ROUTES.PAYMENT}${search}`);
    }
  };

  const handleCancelPendingOrder = async () => {
    if (!isDubbingRoute && latestOrder.status !== ORDER_STATUS.PENDING) return;
    if (isDubbingRoute && latestDubbingOrder.status !== ORDER_STATUS.PENDING)
      return;

    setLoading({ ...loading, cancelOrder: true });
    const orderData = await apis.orders.cancelOrder(latestOrder.id);
    setLoading({ ...loading, cancelOrder: false });
    if (!orderData.status)
      dispatch(actions.noti.push({ severity: 'error', code: orderData.code }));
    else {
      if (pkg.result.type === PACKAGE_TYPE.STUDIO)
        dispatch(actions.user.getLatestOrderSuccess(pkg.result));
      else if (pkg.result.type === PACKAGE_TYPE.DUBBING)
        dispatch(actions.user.getLatestDubbingOrderSuccess(pkg.result));

      dispatch(
        actions.noti.push({
          severity: 'success',
          message: 'cancelOrderSuccessfully',
        }),
      );
    }

    setOpenDialog(false);
    setLoading({ ...loading, createFreeOrder: false });
  };

  const handleContinuePayingDialog = () => {
    if (latestOrder.status !== ORDER_STATUS.PENDING) return;
    if (latestOrder.paymentLink)
      window.location.assign(latestOrder.paymentLink);
    else history.replace({ search: `?package=${pkg.code}` });
  };

  const handleCloseDialog = () => setOpenDialog(false);

  const renderButtonTextV3 = () => {
    const isUsingV3Package = Object.values(PACKAGE_CODE_V3)?.includes(
      usingPackage?.code,
    );
    const isUsingFreePkg = FREE_PACKAGE_CODES.includes(usingPackage?.code);

    if (FREE_PACKAGE_CODES.includes(pkg.code))
      return isUsingFreePkg ? t('using') : t('activeNow');

    const hasSamePackage =
      usingPackage?.expiresIn === pkg?.expiresIn &&
      usingPackage?.level === pkg?.level;
    if (
      hasSamePackage ||
      isUpgradePackage ||
      isUsingFreePkg ||
      isExpiredPackage ||
      !isUsingV3Package
    )
      return t('buyNow');

    return t('buyPackageBtnTitle');
  };

  const renderPackagePriceUnit = (value) => {
    if (!value) return '';
    if (value < 1) return `/${t('character')}`;
    return `/${t('month')}`;
  };

  const renderBilledTotalDesc = (packageDuration) => {
    switch (packageDuration) {
      case PACK_DURATION.MONTH:
        return t('billedMonthly');
      case PACK_DURATION.YEAR:
      case PACKAGE_EXPIRED.YEARLY:
        return t('perYear');
      default:
        return '';
    }
  };

  const getPackageContents = ({
    contents,
    maxSeconds,
    packageType,
    packageDuration,
  }) => {
    const isFreePackageV3 = pkg?.code === PACKAGE_CODE.STUDIO_FREE_V3;
    if (packageDuration === DURATION.MONTHLY && isFreePackageV3)
      return contents.filter(
        (item) => !item?.vi?.includes('Không có giọng nhân bản'),
      );
    if (packageType !== PACKAGE_TYPE.DUBBING) return contents;

    // Calculate unit price / minute
    let unitPrice;
    if (isVietNam) unitPrice = Math.round((price / maxSeconds) * 60);
    else {
      unitPrice = (usdPrice / maxSeconds) * 60;
      unitPrice = Math.round(unitPrice * 100) / 100;
    }

    // Create unit price content
    const viUnitPriceContent = {
      vi: `Đơn giá <br><b>₫${unitPrice.toLocaleString(language)} / phút</b>`,
      en: `Unit price <br><b>₫${unitPrice.toLocaleString(
        language,
      )} / minute</b>`,
      active: true,
    };

    const usdUnitPriceContent = {
      vi: `Đơn giá <br><b>$${unitPrice.toLocaleString(language)} / phút</b>`,
      en: `Unit price <br><b>$${unitPrice.toLocaleString(
        language,
      )} / minute</b>`,
      active: true,
    };

    const unitPriceContent = isVietNam
      ? viUnitPriceContent
      : usdUnitPriceContent;
    const newContents = [...contents];
    newContents.splice(1, 0, unitPriceContent);

    return newContents;
  };

  const checkDisplayBuyButton = (studioPackages) => {
    const basicTrialStudioPackages = [PACKAGE_LEVEL.TRIAL];

    return (
      pkg.price > 0 ||
      !studioPackages?.id ||
      basicTrialStudioPackages.includes(studioPackages?.level)
    );
  };
  const displayBuyButton = checkDisplayBuyButton(usingPackage);

  const renderPrice = (priceValue) => {
    let formattedPrice =
      monthlyPriceWithSaleOff > 1
        ? monthlyPriceWithSaleOff?.toLocaleString(language)
        : priceValue?.toLocaleString(language);

    formattedPrice =
      monthlyPriceWithSaleOff?.toLocaleString(language) ||
      priceValue?.toLocaleString(language);

    if (!isVietNam && formattedPrice !== '0') {
      if (duration !== DURATION.MONTHLY) {
        formattedPrice = (totalPrice / 12)?.toLocaleString(language, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      } else {
        const number = +Number(formattedPrice.replace(',', '.'));
        formattedPrice = number.toLocaleString(language, {
          minimumFractionDigits: 2,
        });
      }
    }

    const renderInternationPrice = () => {
      if (isVietNam)
        return (
          <>
            <span className="three-first">
              {/* Format before 4 last character is big */}
              {formattedPrice.slice(0, -4) || '0'}
            </span>
            {/* Format last 4 character is small */}
            <span className="three-last">
              {formattedPrice.slice(-4) === '0' ? '' : formattedPrice.slice(-4)}
            </span>
          </>
        );
      return formattedPrice;
    };

    return (
      <>
        <Typography className="price">
          <span className={`unit-price ${isVietNam ? 'underlined' : ''}`}>
            {isVietNam ? 'đ' : '$'}
          </span>
          {/* PSUGO pakage have month price < 1 */}
          {renderInternationPrice()}
        </Typography>
      </>
    );
  };

  const renderTotalPrice = (value) => (
    <>
      <Typography className="original-price">
        {!isVietNam && <span className="original-price-unit">$</span>}
        {isVietNam && <span className="original-price-unit underlined">đ</span>}
        {value}
      </Typography>
      <Typography className="sub-origin-price">
        {renderBilledTotalDesc(pkg.expiresIn)}
      </Typography>
    </>
  );

  const MostPopularBanner = () => (
    <div className="most-popular-banner">
      <Typography className="most-popular-text">
        {capitalize(t('mostPopular'))}
      </Typography>
    </div>
  );

  const EmptyBanner = () => <div />;

  useEffect(() => {
    const { startAt, endAt } = pkg.discountConfig || {};
    const inDiscountTime = startAt && moment().isBetween(startAt, endAt);
    if (inDiscountTime || pkg.mostPopular) {
      setHighlight(true);
    } else setHighlight(false);

    if (inDiscountTime) setIsDiscountPackage(true);
    else setIsDiscountPackage(false);
  }, [pkg, hasDiscountPackage]);

  useEffect(() => {
    userRef.current = user;
  }, [user]);

  useEffect(() => {
    getBestVoucherForUser();
  }, [canUseVouchers, isDiscountPackage]);

  useEffect(() => {
    if (pkg?.contents) {
      const contents = getPackageContents({
        contents: pkg.contents,
        maxSeconds: pkg.maxSeconds,
        packageType: pkg.type,
        packageDuration: duration,
      });
      setPackageContents(contents);
    }
  }, [pkg?.contents, language, isVietNam, duration]);

  const renderBannerPackage = (discount = {}, mostPopular) => {
    const { startAt, endAt } = discount;
    const inDiscountTime = startAt && moment().isBetween(startAt, endAt);

    const endAtToShow = getFakeEndTimeDiscountForPackage({
      startTimeToCountdown: startAt,
      timeToResetCountdown: DEFAULT_TIME_TO_RESET_COUNTDOWN,
      endTimeToCountdown: endAt,
    });

    if (inDiscountTime) return <NewCountdownBanner endAt={endAtToShow || {}} />;
    if (mostPopular) return <MostPopularBanner />;

    return <EmptyBanner />;
  };

  const getAndSetRemainingValueOfTheCurrentPackage = async (packageType) => {
    const data = await apis.orders.remainingValueOfTheCurrentPackage({
      packageType,
    });

    if (data?.status) setRemainingValueOfTheCurrentPackage(data?.result);
  };

  useEffect(() => {
    // Get remaining value of the current package when using pricing model V3, not buy topup characters, upgrade package
    const checkConditionGetRemainingValue = isUpgradePackage || isCustomPackage;

    if (checkConditionGetRemainingValue) {
      getAndSetRemainingValueOfTheCurrentPackage(
        location.pathname.includes('studio')
          ? PACKAGE_TYPE.STUDIO
          : PACKAGE_TYPE.API,
      );
    }
  }, [isUpgradePackage, location]);

  useEffect(() => {
    const checkConditionGetRemainingValue = isUpgradePackage || isCustomPackage;

    if (checkConditionGetRemainingValue && remainingValueOfTheCurrentPackage) {
      const basePrice = price || pkg?.price;
      const baseUsdPrice = usdPrice || pkg?.usdPrice;

      const { price: remainingPrice = 0, usdPrice: remainingUsdPrice = 0 } =
        remainingValueOfTheCurrentPackage || {};

      const adjustedPrice = Math.max(0, basePrice - remainingPrice);
      const adjustedUsdPrice = Math.max(0, baseUsdPrice - remainingUsdPrice);

      const savedPrice = getSavedPriceBasePrice({
        voucher: bestVoucher,
        currPrice: adjustedPrice,
        currUsdPrice: adjustedUsdPrice,
      });

      const adjustedTotalPrice = getTotalPricePackage({
        voucher: bestVoucher,
        currPrice: adjustedPrice,
        currUsdPrice: adjustedUsdPrice,
        savedPrice,
      });

      setTotalRemainingPrice(adjustedTotalPrice);
    }
  }, [
    remainingValueOfTheCurrentPackage,
    bestVoucher,
    pkg,
    price,
    duration,
    isUpgradePackage,
    isCustomPackage,
  ]);

  const PackagePrice = () => (
    <div className="package-price-container">
      <div className="price-wrapper">
        {/* Monthly price with sale off */}
        <div className="price-package">
          {isVietNam ? renderPrice(price) : renderPrice(usdPrice)}
        </div>
        {/* Monthly original price */}
        {(saleOffPercentage || isDiscountPackage || isDiscountUsingVoucher) && (
          <div className="price-original-discount">
            <Typography>
              {!isVietNam && <span className="discount-unit-price">$</span>}
              {isVietNam && (
                <span className="discount-unit-price underlined">đ</span>
              )}
              <span className="original-price-month">
                {correspondMonthPrice?.toLocaleString(language)}
              </span>
            </Typography>
          </div>
        )}
        {/* Unit */}
        <span className="original-price-not-line-through">
          {renderPackagePriceUnit(pkg.price)}
        </span>
      </div>
      {showPackageTotalPrice && (
        <div className="original-price-wrapper">
          {renderTotalPrice(totalPrice?.toLocaleString(language))}
        </div>
      )}
      {!isMobile && !showPackageTotalPrice && (
        <div className="original-price-wrapper" />
      )}
    </div>
  );

  const renderRandomAvatars = () => {
    const avatarsDay1List = [avatarMP11, avatarMP12, avatarMP13];
    const avatarsDay2List = [avatarMP21, avatarMP22, avatarMP23];
    const avatarsDay3List = [avatarMP31, avatarMP32, avatarMP33];
    const allAvatars = [avatarsDay1List, avatarsDay2List, avatarsDay3List];

    const currentDate = new Date();
    const dayOfWeek = currentDate.getDay();
    return allAvatars[dayOfWeek % allAvatars.length];
  };

  const isUiBuyTopupCharacters = useMemo(() => {
    const isFreePackageV3 = user?.packageCode === PACKAGE_CODE.STUDIO_FREE_V3;
    return (
      usingPackage?.level === pkg?.level &&
      !!usingPackage?.topUpPackageCode &&
      !isFreePackageV3 &&
      !isExpiredPackage
    );
  }, [user, pkg, isExpiredPackage, usingPackage]);

  const buttonBuyPackageView = () => (
    <Button
      fullWidth
      className={classnames('button-start', {
        'button-highlight': highlight && pkg.mostPopular,
      })}
      variant={highlight && pkg.mostPopular ? 'contained' : 'outlined'}
      data-id="add-to-cart"
      data-product={pkg?.type}
      data-package-code={pkg?.code}
      data-pricing-duration={duration}
      data-button-text={renderButtonTextV3()}
      onClick={() => handleBuyPackage(null)}
      disabled={!displayBuyButton && !isExpiredPackage}
    >
      {renderButtonTextV3()}
    </Button>
  );

  return (
    <>
      <StyledNewPackageItemWrapper
        isPoppular={pkg.mostPopular}
        isMobile={isMobile}
      >
        {renderBannerPackage(pkg.discountConfig, pkg.mostPopular)}
        <StyledNewPackageItemV2
          isPoppular={pkg.mostPopular}
          isMobile={isMobile}
          highlight={highlight}
          isDiscountPackage={
            isDiscountPackage || (pkg.mostPopular && !hasDiscountPackage)
          }
          isVietNam={isVietNam}
          isDisableButton={!displayBuyButton && !isExpiredPackage}
        >
          <div className="card">
            <div className="card-package" role="button" tabIndex="0">
              <div className="card-pacakge-main-content pricing-top-section">
                {/** Package Header */}
                <PackageHeader
                  data={pkg}
                  bestVoucher={bestVoucher}
                  isApplyFirstPaidVoucher={isApplyFirstPaidVoucher}
                />

                {/** Package Price */}
                <PackagePrice />

                <div className="credit-slider-and-package-content">
                  {pkg?.cycle?.creditOptions?.length > 0 &&
                    marks?.length > 0 && (
                      <NewCreditsSlider
                        maxNumberOptionCredit={maxNumberOptionCredit}
                        minNumberOptionCredit={minNumberOptionCredit}
                        marks={marks}
                        currentCredits={currentCredits}
                        handleChangeCredits={handleChangeCredits}
                      />
                    )}
                  <List className="list-package-content">
                    <AmountCredits
                      pkg={pkg}
                      bestVoucher={bestVoucher}
                      newPricingOverviewEnabled
                    />
                    {packageContents?.map((item) => (
                      <Box
                        alignItems="center"
                        display="flex"
                        justifyContent="space-between"
                      >
                        <div
                          className="clarify package-content-item"
                          key={item.vi}
                        >
                          <div className="flexItem">
                            <div className="icon-contents">
                              {item.active ? (
                                <FiberManualRecordRoundedIcon className="dots" />
                              ) : (
                                <Clear fontSize="small" color="light" />
                              )}
                            </div>
                            <div
                              className={
                                item.active ? 'content' : 'content-deactivate'
                              }
                              // eslint-disable-next-line react/no-danger
                              dangerouslySetInnerHTML={{
                                __html:
                                  language === LANGUAGE.VN
                                    ? item?.[language]
                                        .replaceAll(',', '.')
                                        .replaceAll(
                                          '<b>',
                                          `<b style='white-space:nowrap'>`,
                                        )
                                    : item[LANGUAGE.EN],
                              }}
                            />
                          </div>
                          <div className="tooltip">
                            {!isMobile && item?.tooltip && (
                              <Tooltip
                                arrow
                                className="tootlip"
                                title={item?.tooltip?.[language] || ''}
                                placement="left"
                              >
                                <InfoOutlinedIcon />
                              </Tooltip>
                            )}
                          </div>
                        </div>
                      </Box>
                    ))}
                  </List>
                </div>

                <div
                  className="buy-package-btn-container"
                  style={{ minHeight: buyContainerMinHeight }}
                >
                  <div>
                    {buttonBuyPackageView()}
                    {pkg.mostPopular && (
                      <div className="popularity">
                        <StackedAvatars images={renderRandomAvatars(false)} />
                        <Typography
                          className="popularity-text"
                          variant="body2"
                          sx={{ color: COLOR.black[64] }}
                        >
                          {t('mostPeopleChooseThis', {
                            percent: pkg?.popularPercent || 86,
                          })}
                        </Typography>
                      </div>
                    )}
                  </div>
                  {isUiBuyTopupCharacters && (
                    <Button
                      fullWidth
                      className="buy-extra-characters-button"
                      variant="outlined"
                      onClick={() => handleBuyPackage(pkg?.topUpPackageCode)}
                    >
                      <AddRoundedIcon /> {t('buyMoreCredits')}
                    </Button>
                  )}
                </div>
              </div>

              {!!pkg?.featuresDescription?.length && <Divider />}

              <div className="card-content">
                {!!pkg?.featuresTitle && (
                  <Typography
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHtml(
                        language === LANGUAGE.VN
                          ? pkg?.featuresTitle?.[language]
                          : pkg?.featuresTitle?.[LANGUAGE.EN],
                      ),
                    }}
                    className="title-text"
                  />
                )}
                {pkg?.featuresDescription?.length > 0 && (
                  <List
                    style={{
                      gap: '12px',
                      display: 'flex',
                      flexDirection: 'column',
                      padding: 0,
                    }}
                  >
                    {pkg?.featuresDescription?.map((item) => (
                      <Box display="flex" justifyContent="space-between">
                        <ListItem className="clarify" key={item.vi}>
                          <Box style={{ width: '100%' }} className="flexItem">
                            <div className="flexItem">
                              <div className="icon-contents">
                                <Check
                                  fontSize="small"
                                  className={
                                    item?.advanced
                                      ? 'check-icon coming-soon-text-advanced'
                                      : 'check-icon'
                                  }
                                />
                              </div>
                              <span className="item-package">
                                <div
                                  className={
                                    item?.advanced
                                      ? 'coming-soon-text-advanced content'
                                      : 'coming-soon-text content'
                                  }
                                >
                                  {language === LANGUAGE.VN
                                    ? item[language]
                                    : item[LANGUAGE.EN]}
                                  {item?.comingSoon && (
                                    <span className="coming-soon-title">
                                      ({t('comingSoon')})
                                    </span>
                                  )}
                                </div>
                              </span>
                            </div>
                            <div className="tooltip">
                              {!isMobile && item?.tooltip && (
                                <Tooltip
                                  arrow
                                  title={item?.tooltip?.[language] || ''}
                                  placement="left"
                                  className="tootlip"
                                >
                                  <InfoOutlinedIcon />
                                </Tooltip>
                              )}
                            </div>
                          </Box>
                        </ListItem>
                      </Box>
                    ))}
                  </List>
                )}
                {packagesComparisonEnabled && (
                  <CustomTypography
                    variant="body-14-semibold"
                    color="#1C1C1EA3"
                    onClick={scrollToPackagesComparison}
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    {t('viewDetail')}{' '}
                    <ArrowForwardIosRoundedIcon
                      sx={{ fontSize: 12, color: '#1C1C1EA3' }}
                    />
                  </CustomTypography>
                )}
              </div>
            </div>
            <div>
              {isMobile &&
                pkg?.contents?.flatMap((item) =>
                  item?.tooltip ? (
                    <span className="note">
                      (*){' '}
                      <span
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                          __html: sanitizeHtml(
                            language === LANGUAGE.VN
                              ? item?.tooltip?.[language]
                              : item?.tooltip?.[LANGUAGE.EN],
                          ),
                        }}
                      />
                    </span>
                  ) : (
                    []
                  ),
                )}
            </div>
          </div>

          {pkg.price === 0 && (
            <NotificationDialog
              name="pendingOrder"
              title={t('havePendingOrderTitle')}
              description={t('hasOrderWaitForConfirmTransferDescription')}
              variant="warning"
              open={openDialog}
              onClose={handleCloseDialog}
              actionComponent={
                <>
                  <Button variant="outlined" onClick={handleCancelPendingOrder}>
                    <ProcessHandler loading={loading.cancelOrder} size={25}>
                      {t('cancelOrder')}
                    </ProcessHandler>
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleContinuePayingDialog}
                  >
                    {t('continue')}
                  </Button>
                </>
              }
            />
          )}
        </StyledNewPackageItemV2>
      </StyledNewPackageItemWrapper>
    </>
  );
};

export default NewPackageItem;
